import { RouterProvider } from "react-router";
import { router } from "./Router";

export default function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="w-full">
        <RouterProvider router={router} />
      </div>
    </div>
  );
}
